import { Component, Vue, Prop } from 'vue-property-decorator';
import { IMatchup, IPick } from '@/store/modules/game/interfaces';
import { GetOUFantasyProjection } from '@/utils/GameUtils'
import { FormatEventName, FormatEventDate } from '@/utils/GameUtils'
import { IMatchupType } from './Matchup';

@Component
export default class OverUnder extends Vue implements IMatchupType {
  @Prop() matchup: IMatchup;

  private selectClick(pick: IPick) {
    const selected = this.$store.getters.HAS_SELECTION(pick.matchupId, pick.player.id) 
    if (selected) {
      // @ts-ignore
      this.$parent.removeClick(this.matchup, pick, 'ou')
    } else {
      // @ts-ignore
      this.$parent.selectClick(this.matchup, pick, 'ou')
    }
  }

  private render(h: any): any {
    const pick = this.matchup.pickA
    const oselected = this.$store.getters.HAS_SELECTION(this.matchup.id, this.matchup.pickA.player.id) ? 'active' : ''
    const uselected = this.$store.getters.HAS_SELECTION(this.matchup.id, this.matchup.pickB.player.id) ? 'active' : ''
    // @ts-ignore
    const imgSrc = this.$parent.expandAssetUrl(pick.player.tags) || '/white.jpg'
    return (
      <div class='avatar-card overunder'>
        <div class='avatar'>
          <img class='avatar-portrait' src={imgSrc} height='60' width='60' onError={(e: any)=>{e.target.onerror = null; e.target.src='/white.jpg'}}></img>

          <span class='avatar-position'>{pick.player.position}</span>
          <p class='avatar-name'>{pick.player.shortName}</p>
          <p class='avatar-event-name'>{FormatEventName(pick)}</p>
          <p class='avatar-event-date'>{FormatEventDate(pick)}</p>

          <p class='avatar-fppg'>
            <span class='avatar-fppg-stat'>{pick.player.fppg}</span>
            <span class='avatar-fppg-label'>FPPG</span>
          </p>

          <div class={`avatar-ouopt ${oselected}`}>
            <span class='fbutton button-action' onClick={this.selectClick.bind(this, this.matchup.pickA)}>Over</span>
          </div>

          <p class='avatar-fpscore'>{GetOUFantasyProjection(this.matchup.pickB)}</p>

          <div class={`avatar-ouopt right ${uselected}`}>
            <span class='fbutton button-action' onClick={this.selectClick.bind(this, this.matchup.pickB)}>Under</span>
          </div>

          <div class='avatar-stats-overlay'></div>
        </div>
      </div>
    );
  }
}
